<mat-progress-bar
  data-at-progress-bar
  id="progress-bar"
  *ngIf="isLoading"
  mode="indeterminate"
  class="get-loader"
></mat-progress-bar>
